import { render } from "./com_productos.vue?vue&type=template&id=64487454&scoped=true"
import script from "./com_productos.vue?vue&type=script&lang=js"
export * from "./com_productos.vue?vue&type=script&lang=js"

import "./com_productos.vue?vue&type=style&index=0&id=64487454&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64487454"]])

export default __exports__